import { useEffect, useState, useSyncExternalStore } from 'react';
import { dismissToast, getToasts, subscribeToasts, type ToastItem } from '../core/toast';
import { Icon } from './icons';

function Toast({ item }: { item: ToastItem }) {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const raf = requestAnimationFrame(() => setShown(true));
    const hide = setTimeout(() => setShown(false), item.ms);
    const remove = setTimeout(() => dismissToast(item.id), item.ms + 300);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(hide);
      clearTimeout(remove);
    };
  }, [item]);
  return (
    <div className={`toast${item.tone ? ` t-${item.tone}` : ''}${shown ? ' in' : ''}`}>
      {item.icon ? <Icon name={item.icon} /> : null}
      <span>{item.text}</span>
    </div>
  );
}

export function Toaster() {
  const items = useSyncExternalStore(subscribeToasts, getToasts);
  return (
    <div className="toasts" id="toasts" role="status" aria-live="polite">
      {items.map((t) => (
        <Toast key={t.id} item={t} />
      ))}
    </div>
  );
}
